/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-unused-state */
import React from 'react'
import { IApiOptions, IImportExcelMenuItem, ISelectedStoreMap, IStoreWebsite, IXScreenProps } from 'x/index'
import * as NavActions from 'x/utils/navigation'
import * as util from 'x/utils/util'
import _ from 'lodash'
import apiCustom from 'x/utils/api'
import * as api from 'x/utils/api'
import p from 'x/config/platform-specific'
import { StackNavigationProp } from '@react-navigation/stack'

interface IHamburgerChannelMenuOptions {
  key: string
  label: string
  onPress: () => void | Promise<void>
  icon?: {
    name: string
    family?:
      | 'AntDesign'
      | 'Entypo'
      | 'EvilIcons'
      | 'Feather'
      | 'FontAwesome'
      | 'FontAwesome5'
      | 'Foundation'
      | 'Ionicons'
      | 'MaterialCommunityIcons'
      | 'MaterialIcons'
      | 'Octicons'
      | 'SimpleLineIcons'
      | 'Zocial'
  }
  perm?: string | string[]
  isValidation: () => boolean
  isDanger?: boolean
}

// @ts-ignore
interface IBaseSalePageViewProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
  subscription: any
  navigation: StackNavigationProp<any>
}

interface IBaseSalePageViewState {
  salePage: IStoreWebsite
  hamburgerMenuOptions: IHamburgerChannelMenuOptions[]
  isHamburgerMenuOpened: boolean
  containerWidth: number

  isInitialized: boolean

  isLoading: boolean
}

export default abstract class BaseSalePageView extends React.Component<IBaseSalePageViewProps, IBaseSalePageViewState> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  MENU_ITRMS: IImportExcelMenuItem[]

  constructor(props) {
    super(props)
    this.state = {
      salePage: null,
      hamburgerMenuOptions: null,
      isHamburgerMenuOpened: false,
      containerWidth: 320,
      isInitialized: true,
      isLoading: false,
    }
    // this.webview = React.createRef()
    this.MENU_ITRMS = [
      {
        label: 'ตั้งค่าเว็บไซต์',
        isHeader: true,
        isShowMenu: () => true,
      },
      {
        label: 'ตั้งค่าทั่วไป',
        // iconName: 'group',
        // iconFamily: 'MaterialIcons',
        onclick: () => this._navToSalePageEditInfoView(),
        isShowMenu: () => true,
      },
      {
        label: 'การจัดส่ง',
        // iconName: 'group',
        // iconFamily: 'MaterialIcons',
        onclick: () => this._navToStoreWebsiteSettingPaymentView(),
        isShowMenu: () => true,
      },
      {
        label: 'คำสั่งซื้อ',
        // iconName: 'group',
        // iconFamily: 'MaterialIcons',
        onclick: () => this._navToStoreWebsiteSettingOptionsOrderView(),
        isShowMenu: () => true,
      },
      {
        label: 'Pixel',
        // iconName: 'group',
        // iconFamily: 'MaterialIcons',
        onclick: () => this._navToSalePageEditPixelView(),
        isShowMenu: () => true,
      },
      {
        label: 'เว็บไซต์',
        // iconName: 'group',
        // iconFamily: 'MaterialIcons',
        onclick: () => this._navToSalePageSettingWebView(),
        isShowMenu: () => true,
      },
    ]
  }

  async componentDidMount() {
    // const params = util.getNavParams(this.props)
    // const { salePage } = params
    // if (_.isNil(salePage)) {
    //   this.setState({
    //     // @ts-ignore
    //     salePage: {
    //       template: 'sale_page_one_option',
    //       name: 'หูฟังคุณภาพ ลดพิเศษสำหรับเทศกาลฤดูลดราคาที่กำลังมาแรงในขณะนี้',
    //       id: 456123,
    //       created_at: '2023-07-16 10:30:27',
    //     },
    //   })
    // } else {
    //   this.setState({ salePage })
    // }

    await this._fetchWebsiteDetail()
    await this._configHamburgerMenuItems()
  }

  _fetchWebsiteDetail = async () => {
    const { selectedStore } = this.props
    // @ts-ignore
    const sp = util.getNavParam(this.props, 'salePage')

    try {
      const storeWebSiteDetail = await api.getStoreWebsite({ store_id: selectedStore.get('id'), website_id: sp.id })
      if (storeWebSiteDetail.id) {
        this.setState({ salePage: storeWebSiteDetail })
      }
    } catch (error) {
      // console.log('_fetchWebsiteDetail error => ', error)
    }
  }

  _configHamburgerMenuItems = async () => {
    const menu = []

    const deleteWebsite: IHamburgerChannelMenuOptions = {
      key: 'delete_store_website',
      label: 'ลบเว็บไซต์',
      onPress: () => this._deletedWebsite(),
      icon: { name: 'close-o', family: 'EvilIcons' },
      isDanger: true,
      isValidation: () => true,
    }

    menu.push(deleteWebsite)

    // if (isActive) {
    //   menu.push(unAuthErp)
    // } else {
    //   menu.push(authErp)
    // }

    await util.setStatePromise(this, {
      hamburgerMenuOptions: menu,
    })
  }

  _navToSalePageSettingWebView = () => {
    const { salePage } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToSalePageSetttingWebView({
        storeWebsite: salePage,
      })
    )
  }

  _callBackForUpdateStoreWebsite = (newShippingSetting: IStoreWebsite) => {
    this.setState({ salePage: newShippingSetting })
    // @ts-ignore
    const callBackForSucceedEditStoreWebsite = util.getNavParam(this.props, 'callBackForSucceedEditStoreWebsite')
    if (_.isFunction(callBackForSucceedEditStoreWebsite)) {
      callBackForSucceedEditStoreWebsite(newShippingSetting)
    }
  }

  _navToStoreWebsiteSettingPaymentView = () => {
    const { salePage } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToStoreWebsiteSettingPaymentView({
        storeWebsite: salePage,
        callBackSucceedUpdateApi: (newStoreWebsite: IStoreWebsite) => this._callBackForUpdateStoreWebsite(newStoreWebsite),
      })
    )
  }

  _navToStoreWebsiteSettingOptionsOrderView = () => {
    const { salePage } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToStoreWebsiteSettingOptionsOrderView({
        storeWebsite: salePage,
        callBackSucceedUpdateApi: (newStoreWebsite: IStoreWebsite) => this._callBackForUpdateStoreWebsite(newStoreWebsite),
      })
    )
  }

  _navToSalePageEditInfoView = () => {
    const { salePage } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToSalePageEditInfoView({
        salePage,
        callBackSucceedUpdateApi: (newStoreWebsite: IStoreWebsite) => this._callBackForUpdateStoreWebsite(newStoreWebsite),
      })
    )
  }

  _navToSalePageEditPixelView = () => {
    const { salePage } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToSalePagePixelView({
        salePage,
        callBackSucceedUpdateApi: (newStoreWebsite: IStoreWebsite) => this._callBackForUpdateStoreWebsite(newStoreWebsite),
      })
    )
  }

  _confirmChangeMkpSetting = async () => {
    const confirm = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        'ลบเว็บไซต์?',
        'กดปุ่มยืนยันหากคุณต้องการลบเว็บไซต์',
        () => passConfirm(true),
        () => passConfirm(false),
        'ยืนยัน',
        'ยกเลิก'
      )
    })
    return confirm
  }

  _deletedWebsite = async () => {
    const { salePage } = this.state
    const { selectedStore } = this.props

    const confirm = await this._confirmChangeMkpSetting()
    if (!confirm) {
      return
    }

    const store_id = selectedStore.get('id')
    const reqBody = {
      store_id,
      website_id: salePage.id,
    }

    // const apiOptions: IApiOptions = {
    //   showSpinner: true,
    // }

    // const res: {
    //   status: 'ok'
    // } = await api.postV2('store/website/delete', reqBody, apiOptions)

    // console.log('DELETED res! => ', res)

    // if (res.status === 'ok') {
    //   util.navGoBack(this.props)
    //   p.op.showToast('ลบเว็บไซต์เรียบร้อยแล้ว', 'success')
    // }

    const isDeleted = await api.deleteStoreWebsite(reqBody)

    if (isDeleted) {
      // @ts-ignore
      util.navGoBack(this.props)
      // @ts-ignore
      const callBackForSucceedDeleteStoreWebsite = util.getNavParam(this.props, 'callBackForSucceedDeleteStoreWebsite')
      if (_.isFunction(callBackForSucceedDeleteStoreWebsite)) {
        callBackForSucceedDeleteStoreWebsite()
      }
    }
  }

  _confirmGoPublish = async () => {
    const confirm = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        'เผยแพร่แบบร่าง?',
        'กดปุ่มยืนยันหากคุณต้องการเผยแพร่แบบร่างสู่เว็บไซต์',
        () => passConfirm(true),
        () => passConfirm(false),
        'ยืนยัน',
        'ยกเลิก'
      )
    })
    return confirm
  }

  _goPublish = async () => {
    const { selectedStore } = this.props
    const { salePage } = this.state

    if (_.isNil(salePage)) {
      return
    }

    const haveDraftConfigJson = _.has(salePage, 'draft_config_json')
    const draftConfigJson = haveDraftConfigJson ? salePage.draft_config_json : null
    const haveDefaultShippingAndPayment = _.has(draftConfigJson, 'default_shipping_and_payment')
    const haveOrderPickers = _.has(draftConfigJson, 'order_pickers')
    const haveWebItems = _.has(draftConfigJson, 'web_items')
    if (!haveDefaultShippingAndPayment || !haveOrderPickers || !haveWebItems) {
      p.op.showConfirmationOkOnly('', 'กรุณาตั้งค่าให้เรียบร้อยก่อนเผยแพร่แบบร่าง')
      return
    }

    const confirm = await this._confirmGoPublish()
    if (!confirm) {
      return
    }

    await util.setStatePromise(this, { isLoading: true })
    await util.delay(200)
    // const newJson = _.has(salePage, 'draft_config_json') ? _.cloneDeep(salePage.draft_config_json) : { draft_config_json: null }
    try {
      const store_id = selectedStore.get('id')
      const reqBody = {
        store_id,
        website_id: salePage.id,
      }

      const apiOptions: IApiOptions = {
        showSpinner: true,
      }
      const res = await apiCustom.postV2('store/website/publish', reqBody, apiOptions)
      console.log('res => ', res)
      if (res.id) {
        await util.setStatePromise(this, {
          salePage: res,
        })
        p.op.showToast('เผยแพร่แบบร่างเรียบร้อยแล้ว', 'success')
      }
    } catch (error) {
      // console.log('error => ', error)
    }
    await util.delay(200)
    await util.setStatePromise(this, { isLoading: false })
  }
}
